function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.86 5.53L1.52.19A.68.68 0 001.05 0a.66.66 0 00-.46.19L.2.58a.65.65 0 000 .93L4.68 6 .19 10.49A.66.66 0 000 11a.68.68 0 00.19.47l.39.39a.68.68 0 00.47.19.66.66 0 00.46-.19l5.35-5.4A.66.66 0 007.05 6a.68.68 0 00-.19-.47z",
  fill: "#61c250"
});

function SvgChevronRight(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 7.05 12"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/chevron-right.957e76a8.svg";
export { SvgChevronRight as ReactComponent };